import map from 'lodash/map';

const selectAttributesChartLayers = (phrases, chartLayers, comparison) => {
  const layerName = ({ dataKey }) => (
    (dataKey === 'ranking' || !comparison) ? phrases[`${dataKey}ChartLayerName`] : comparison.name
  );

  return map(chartLayers, value => ({
    ...value,
    name: layerName(value),
  }));
};

export default selectAttributesChartLayers;
